import React from "react";

import { getContactMailUrl, navigate, openURL } from "../../../helpers/utils";

import Header from "../common/header";
import {
  View,
  StyleSheet,
  Text,
  ScrollView,
  TouchableOpacity,
  Platform,
} from "react-native";

import appStyles from "../../appStyles";
import TutorialsHelper from "../tutorials/TutorialsHelper";
import AppTheme from "../AppTheme";
import AddGoalIcon from "../common/ActionsMenuButton/icons/AddGoalIcon";
import TrackFabIcon from "../common/ActionsMenuButton/icons/TrackFabIcon";
import ManaButton from "../common/ManaButton";
import HowtoUseJournalIcon from '../common/icons/HowtoUseJournalIcon';

export default class HelpPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    this.state = {
      userList: this.controller.state.users,
    };
  }

  goBack = () => {
    navigate(this.controller, "rn:home_card");
  };

  render() {
    const controller = this.controller;

    const tutorials = [
      {
        id: 102,
        name: "How do I set a goal",
        key: "goals",
        storageKey: TutorialsHelper.STORAGE_KEYS.goals,
        page: "rn:home_card",
        icon: AddGoalIcon,
      },
      {
        id: 103,
        name: "How do I track time?",
        key: "track",
        storageKey: TutorialsHelper.STORAGE_KEYS.track,
        page: "rn:journal",
        icon: TrackFabIcon,
      },
      /* {
        id: 101,
        name: "How do I reflect on last week?",
        key: "reflection",
        storageKey: TutorialsHelper.STORAGE_KEYS.reflection,
        page: "rn:home_card",
        icon: ReflectIcon,
      }, */
      {
        id: 104,
        name: "How do I use journals?",
        key: "journal",
        storageKey: TutorialsHelper.STORAGE_KEYS.reflection,
        page: "rn:sets_reflection",
        icon: HowtoUseJournalIcon,
      },
    ];

    return (
      <View style={[appStyles.container, { marginBottom: 0 }]}>
        <Header
          title="Help"
          subTitle="Interactive Guides to our favorite features"
          hideAvatar
          returnPage="rn:more"
          controller={controller}
        />

        <ScrollView style={[appStyles.scrollView, styles.scrollView]}>
          {tutorials.map((t) => (
            <TouchableOpacity
              style={styles.row}
              key={t.id}
              onPress={() => TutorialsHelper.onTutorialClicked(controller, t)}
            >
              {t.icon ? (
                <View style={appStyles.iconContainer}>
                  <t.icon width={20} height={20} />
                </View>
              ) : null}

              <Text style={styles.optionText}>{t.name}</Text>
            </TouchableOpacity>
          ))}

          <View
            style={{
              marginTop: 24,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ManaButton
              isMainButton
              onPress={() => openURL(getContactMailUrl())}
              style={styles.button}
              styleText={styles.buttonText}
              text="Contact us"
            />
          </View>
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  scrollView: {
    backgroundColor: AppTheme.containerWhite,
    paddingHorizontal: 14,
  },
  row: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: 44,
    borderBottomWidth: 1,
    borderBottomColor: "#F5F5F5",
    paddingLeft: 16,
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  optionText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
  button: {
    borderRadius: 6,
    width: 158,
    height: 40,
  },
  buttonText: {
    fontFamily:  Platform.select({ default: "Montserrat", android: "Montserrat-SemiBold" }),
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 20,
    letterSpacing: 1,
  },
});
